import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.formSubmit = this.element.querySelector('[data-field="location"]').dataset.submit || false
    this.initializeAutocomplete()
  }

  initializeAutocomplete() {
    const autocompleteNode = this.element.querySelector('[data-field="location"]')
    const latField = this.element.querySelector('[data-field="lat"]')
    const lngField = this.element.querySelector('[data-field="lng"]')
    const lnglatRandField = this.element.querySelector('[data-field="lnglat_rand"]')

    if (!autocompleteNode) return

    const autocomplete = new google.maps.places.Autocomplete(autocompleteNode, {
      componentRestrictions: { country: ['fr', 'be', 'ch', 'mc', 'lu'] }
    })

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace()
      if (!place.geometry) return

      if (latField) latField.value = place.geometry.location.lat()
      if (lngField) lngField.value = place.geometry.location.lng()
      if (lnglatRandField) lnglatRandField.value = place['types']?.includes('locality')

      if (this.formSubmit) {
        autocompleteNode.closest('form').submit()
      }
    })

    autocompleteNode.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault()
        e.target.value = ''
        e.target.blur()
      }
    })

    autocompleteNode.addEventListener('change', () => {
      if (autocompleteNode.value === '') {
        if (latField) latField.value = ''
        if (lngField) lngField.value = ''
      }
    })
  }
}

